import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { UserName } from 'modules/user/avatarbox.component';
import AvatarBox from 'modules/user/UAvatar.component';
import { View, Row, SecondaryText, InlineText, InlineLink } from 'modules/styled';
import { getTimestamp } from 'app/utils/numbers';
import { CommentEl, TagEl } from 'modules/post/postTitle.component';
import { goToProfile } from 'modules/navigation/navigation.actions';
// import { getTitle } from 'utils/text';

CommentInfo.propTypes = {
  comment: PropTypes.object,
  user: PropTypes.object,
};

export default memo(CommentInfo);

function CommentInfo({ comment, user }) {
  // const { isHeading, titleText } = getTitle(comment.body);
  // {isHeading && <Header inline={1}>{titleText}</Header>}
  // {!isHeading && titleText && <Highlight>{titleText}</Highlight>}

  user = user || comment.embeddedUser;

  return (
    <Row sx={{ flex: 1, alignItems: 'center' }}>
      <AvatarBox size={7} vertical user={user} />
      <View sx={{ flex: 1, ml: 2, mr: [2, 3] }}>
        <InfoRow comment={comment} user={user} />
        <Row
          sx={{ flexWrap: 'wrap', alignItems: 'flex-end', height: 4, overflow: 'hidden' }}
          numberOfLines={1}
        >
          <CommentEl post={comment} postUrl />
          <TagEl post={comment} />
        </Row>
      </View>
    </Row>
  );
}

InfoRow.propTypes = {
  comment: PropTypes.object,
  user: PropTypes.object,
};

function InfoRow({ comment, user }) {
  const dispatch = useDispatch();
  const postTime = comment.createdAt;

  const timestamp = !!postTime && ' • ' + getTimestamp(postTime);
  if (!comment.embeddedUser) return null;
  const { handle } = comment.embeddedUser;

  return (
    <InlineLink
      to={`/user/profile/${handle}`}
      nativeAction={() => dispatch(goToProfile(handle))}
    >
      <InlineText>
        <UserName user={user} showRel />
        <SecondaryText sx={{ mt: 2.01 }}>
          {'\n'}@{handle} {timestamp}
        </SecondaryText>
      </InlineText>
    </InlineLink>
  );
}
